import Vue from "vue";
import router from "../router";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-LNHGZM79DZ" },
  appName: 'Portifolio',
  pageTrackerScreenviewEnabled: true
}, router)
